<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Card di contenimento della pagina -->
    <b-card title="Generazione chiavi di cifratura" class="mr-1 ml-1">

      <!-- Card di contenimento delle info e del pulsante di generaizone delle chiavi -->
      <b-card no-body>
        <b-card-header>
          <h5><font-awesome-icon icon="key" class="ml-1" size="lg"/> Genera coppia di chiavi</h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col>
              <p>Cliccando sul bottone "Genera chiavi" sarà prodotta una nuova coppia chiave pubblica/chiave privata. Al termine della procedura il browser scaricherà le due come files ( public.bin e private.bin ).</p>
              <p>Ricorda che in seguito <b>non sarà più possibile effettuare il download della chiave privata</b> in quanto il sistema non ne tiene traccia al fine di preservare la privacy dell'utente.</p>
              <p>E' quindi molto importante che questo file sia conservato con cura per tutta la durata del suo utilizzo.</p>
              <p>Se per qualsiasi motivo il download non avviene correttamente, è possibile generare una nuova coppia di chiavi cancellando dalla lista sottostante quella appena generata.</p>
              <p><b>Una volta cancellata una chiave dalla lista sottostante questa cesserà di funzionare e la chiave privata associata diverrà inservibile.</b></p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <b-button variant="danger" @click="genera_chiavi">
                <font-awesome-icon icon="cog" class="ml-1"/> Genera chiavi di cifratura
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- Card di contenimento della tabella delle chiavi attive -->
      <b-card no-body class="mt-3">
        <b-card-header>
          <h5><font-awesome-icon icon="list-ul" class="ml-1" size="lg"/> Chiavi attive</h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <!-- Select per la scelta del numero di elmenti da visualizzare -->
            <b-col cols="12" md="2">
              <b-form-group id="group-page-size"
                  label="Elementi visualizzati:"
                  label-for="page-size">
                <b-form-select id="page-size"
                              v-model="datatable.page_size"
                              :options="datatable.page_size_opt">
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Tabella delle chiavi -->
            <b-col>
              <b-table responsive
                      ref="keytable"
                      stacked="md"
                      :per-page="datatable.page_size"
                      :current-page="datatable.page"
                      :items="get_table_item"
                      :fields="datatable.fields"
                      :busy="datatable.busy"
                      show-empty>

                <!-- Ridefiniamo la colonna dello api user, se non esiste mettiamo una stringa invece che il campo vuoto -->
                <template #cell(api_user_name)="data">
                  <span v-if="data.value">{{data.value}}</span>
                  <span v-else>Nessun api user associato</span>
                </template>


                <!-- Ridefiniamo la cella della data creazione per porla nel formato italiano -->
                <template #cell(created)="data">
                  {{ data.value | toitadatetime }}
                </template>

                <!-- Definiamo la colonna delle azioni -->
                <template #cell(action)="data">
                  <!-- Cancellazione della chiave -->
                  <b-link v-b-tooltip.hover.bottom="'Cancella chiave'"
                          @click="cancella_chiave(data.item.id)"
                          class="mr-2">
                    <b-icon icon="trash"></b-icon>
                  </b-link>
                  <!-- Donwload della chiave -->
                  <b-link v-b-tooltip.hover.bottom="'Download chiave pubblica'"
                          @click="esegui_download_chiave('public.bin', data.item.chiave_pubblica)">
                    <b-icon icon="cloud-download"></b-icon>
                  </b-link>
                </template>

                <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
                      chiamata la funzione che prende i dati get_table_items --->
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
                    <strong class="text-primary">Caricamento...</strong>
                  </div>
                </template>

                <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
                      la proprietà "show-empty" alla tabella -->
                <template v-slot:empty>
                  <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/> Nessun elemento disponibile</p>
                </template>
              </b-table>
              <!-- Paginatore della tabella -->
              <b-pagination v-model="datatable.page" :per-page="datatable.page_size" :total-rows="datatable.items_tot" align="center"></b-pagination>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

    </b-card>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'
import jsrsasign from 'jsrsasign'

export default {
    name: 'ChiaviChain',
    data () {
      return {
        tagline_elem : [ { text : "Generazione chiavi di cifratura", link: "office-cifratura-chain" } ],

        // Elementi per la datatable
        datatable : {

          // Pone la tabella in stato busy. In fase di
          // caricamento dati è gestito in automatico,
          // ci serve invece quando eseguiamo le azioni
          // come per esempio la cancellazione delle chiavi.
          busy: false,

          // Pagina attuale
          page : 1,

          // Numero di elementi per pagina
          page_size : 50,

          // Elementi totali
          items_tot : 0,

          // Numero di pagine che è possibile visualizzare
          page_size_opt: [
            { value: 10,  text: '10'  },
            { value: 25,  text: '25'  },
            { value: 50,  text: '50'  },
            { value: 100, text: '100' },
            { value: 500, text: '500' }
          ],

          // Campi della tabella
          fields : [
            {
              key: 'chiave_pubblica',
              label: 'Chiave Pubblica',
              sortable: true,
              tdClass: 'keycell'
            },
            {
              key: 'api_user_name',
              label: 'Api User',
              sortable: true,
              thClass: 'text-center',
              tdClass: 'text-center'
            },
            {
              key: 'created',
              label: 'Data Generazione',
              sortable: true,
              thClass: 'text-center',
              tdClass: 'text-center'
            },
            // Colonna virtuale per ospitare le icone delle azioni
            {
              key : 'action',
              label: 'Azioni',
              sortable: false,
              thClass: 'text-center',
              tdClass: 'text-center'
            }
          ]
        }
      }
    },
    methods: {
      /**
       * Genera la coppia di chiavi associando la chiave pubblica all'azienda
       * nel momento del savataggio su database e la scarica sul pc dell'utente.
       * Le chiavi sono del tipo a 1024 bit nel formato PEM PKCS8.
       */
      genera_chiavi : function () {
        const chiavi = jsrsasign.KEYUTIL.generateKeypair ( 'RSA', 1024 );
        const chiavePrivataPEM = jsrsasign.KEYUTIL.getPEM ( chiavi.prvKeyObj, "PKCS8PRV" );
        const chiavePubblicaPEM = jsrsasign.KEYUTIL.getPEM ( chiavi.pubKeyObj );

        // Mettiamo un timeout di mezzo secondo tra i due salvataggi perchè questo
        // migliora il comportamento in firefox. Infatti non sempre si aveva lo scaricamento
        // di ambedue i files.
        setTimeout( () => {
          this.esegui_download_chiave( 'private.bin', chiavePrivataPEM );
        },
        500);

        setTimeout( () => {
          this.esegui_download_chiave( 'public.bin', chiavePubblicaPEM );
        },
        500);

        // Salviamo la chiave pubblica sul db. In automatico sarà associata
        // all'azienda dell'utente loggato.
        const call_data = { chiave_pubblica : chiavePubblicaPEM };
        axios.post( apiUrl.pdoppiaapi.add_chiave_pubblica, call_data )
        .then( ( respose ) => {
          // In caso di successo la funzione torna un 201 Created, quindi
          // aggiorniamo la tabella e notifichiamo l'operazione avvenuta
          // all'utente.
          this.$refs.keytable.refresh();
          const mess = "La chiave pubblica generata è ora abilitata per lo scambio dati."
          this.$bvModal.msgBoxOk( mess );
        })
        .catch( ( error ) => {
          generalLib.backend_error_message_box( this, error.response.data );
        });
      },
      /**
       * Funzione di utility per scaricare le chiavi generate sul pc
       * del'utente. Il file generato è text/plain con charset utf-8
       * Riadattato da:
       * https://stackoverflow.com/questions/3665115/create-a-file-in-memory-for-user-to-download-not-through-server
       *
       * - filename: nome da dare al file generato
       * - key: chiave da scaricare (pubblica o privata)
       */
      esegui_download_chiave : function ( filename, key ) {
        let blob = new Blob( [key], {type: 'text/plain;charset=utf-8'} );
        let elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        elem.style.display = 'none';
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
        window.URL.revokeObjectURL(elem);
      },
      /**
       * Funzione per prendere gli elementi della tabella dal backend
       */
      get_table_item : function ( ctx, callback ) {

        const call_url = apiUrl.pdoppiaapi.get_chiavi_pubbliche;
        const params =  { page : ctx.currentPage, page_size : ctx.perPage };

        axios.get( call_url, { params : params } )
        .then( ( response ) => {

          // Elementi totali
          this.datatable.items_tot = response.data.count;

          // Prendiamo i dati che ci servono e togliamo
          // quelli della paginazione
          const items = response.data.results;
          callback( items )
        })
        .catch( ( error ) => {
          generalLib.backend_error_message_box( this, error.response.data );
          callback([])
        });

        // Must return null or undefined to signal b-table that callback is being used
        return null
      },
      /**
       * Esegue la cancellazione della chiave pubblica il cui id è passato alla funzione.
       * Chiede conferma prima di proseguire.
       *
       * - keyid: id della chiave pubblica da cancellare.
       */
      cancella_chiave : function ( keyid ) {
        const message = "Cancellando la chiave pubblica, la relativa chiave privata " +
                        "diverrà inservibile per la lettura dei dati dalla blockchain, " +
                        "sei sicuro di continuare?"
        this.$bvModal.msgBoxConfirm( message, {
          title: 'Cancellazione chiave pubblica',
          centered: true
        })
        .then( ( ok ) => {
          if ( !ok ) return;

          const call_url = apiUrl.pdoppiaapi.delete_chiave_pubblica.replace('@keyid', keyid );
          this.datatable.busy = true;

          axios.delete( call_url )
          .then( ( response ) => {
            // La chiamata torna un 204 No content in caso di successo
            // andiamo quindi a refresciare il contenuto della tabella
            // e a notificare l'avvenuta operazione all'utente
            this.datatable.busy = false;
            this.$bvModal.msgBoxOk('Chiave eliminata')
            .then( (value) => {
              this.$refs.keytable.refresh();
            })
          })
          .catch( ( error ) => {
            this.datatable.busy = false;
            generalLib.backend_error_message_box( this, error.response.data );
          });

        })
      }
    },
    components: {
      PageTagline,
      SwitcherAziende
    }
}
</script>


<style scoped>
/* Classe  */
table :deep( .keycell ) {
  max-width: 600px;
}
</style>